import { Module } from 'vuex'

import { State as RootState } from '@/store/state'
import { actions } from '@/store/persons/labor/actions'
import {
  Labor,
  initState,
  getters,
  mutations,
} from '@/store/persons/labor/state'

const module: Module<Labor, RootState> = {
  namespaced: true,
  state: initState,
  mutations,
  actions,
  getters,
}

export default module
